export default {
    namespaced: true,

    state: {
        referralCount: 0,
        selectMode: false,
        selectedSlots: [],
        maxSlots: 3,
    },

    mutations: {
        SET_REFERRAL_COUNT(state, count) {
            state.referralCount = count
        },
        SET_SELECT_MODE(state, val) {
            state.selectMode = val
            if (!val) state.selectedSlots = []
        },
        SET_MAX_SLOTS(state, val) {
            state.maxSlots = val
        },
        TOGGLE_SLOT(state, slot) {
            const key = `${slot.date}|${slot.startTime}|${slot.endTime}`
            const idx = state.selectedSlots.findIndex((s) => `${s.date}|${s.startTime}|${s.endTime}` === key)
            if (idx !== -1) {
                state.selectedSlots.splice(idx, 1)
            } else if (state.selectedSlots.length < state.maxSlots) {
                state.selectedSlots.push(slot)
            }
        },
        CLEAR_SELECTED(state) {
            state.selectedSlots = []
        },
    },

    getters: {
        referralCount: (state) => state.referralCount,
        selectMode: (state) => state.selectMode,
        selectedSlots: (state) => state.selectedSlots,
        selectedCount: (state) => state.selectedSlots.length,
        maxSlots: (state) => state.maxSlots,
    },
}
